import * as angular from 'angular';
import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { ReferralAccountPagingResult, ReferralAccountListItem, ReferralAccount, StoreListItem } from '../core';
import { IPaginationReferralAccountFilter } from '../api';

export class ReferralAccountsService {
    static $inject = ['http', '$uibModal', 'retailerService'];

    constructor(
        private http: HttpService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private retailerService: RetailerService
    ) {

    }

    searchByReferralCode(code: string) {
        return this.http.get<ReferralAccountListItem>(this.retailerService.shopperByReferralCode(), {
            params: { code: code }
        });
    }

    list(settings: IPaginationReferralAccountFilter) {
        return this.http.get<ReferralAccountPagingResult>(this.retailerService.referralAccounts(), {
            params: settings
        });
    }

    add(model: ReferralAccount) {
        return this.http.post<void>(this.retailerService.referralAccounts(), model);
    }

    update(model: ReferralAccount) {
        return this.http.put<void>(this.retailerService.referralAccounts(), model);
    }

    remove(shopperIDs: number[]) {
        return this.http.delete<void>(this.retailerService.referralAccounts(), {
            params: { id: shopperIDs }
        });
    }

    openAccountManager = (stores: StoreListItem[]) => {
        return this.$uibModal.open({
            component: 'referralAccount',
            resolve: {
                stores: () => stores,
            },
            size: 'md',
            windowClass: 'staffPopup'
        }).result;
    }
}

angular
    .module('naut')
    .service('referralAccountsService', ReferralAccountsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/referral-accounts/referralAccounts.service.ts